export default "__VITE_ASSET__D2z0RnnW__"